import React from 'react'

export function MyCustomPage() {
  return (
    <section>
      <h2>My Custom Page</h2>
      <p>This page is provided by the host app.</p>
    </section>
  )
}

